
document.addEventListener('DOMContentLoaded', function() {

  function fixB2bPriceDisplay() {
    
    // Find all <sale-price> wrappers that contain the specific B2B <del> tag
    // AND have not already been successfully processed by this script.
    document.querySelectorAll('sale-price:not(.b2b-price-is-fixed)').forEach(salePriceWrapper => {

      // Find the key element: the hidden "compare at" price.
      const originalPriceElement = salePriceWrapper.querySelector('del.ymq-b2b-cp-compare-price');

      // --- This is the new, more intelligent check ---
      // If this key element doesn't exist, OR if it's already visible, then do nothing.
      // We only proceed if the element exists AND is still hidden by the app.
      if (!originalPriceElement || !originalPriceElement.classList.contains('ymq-b2b-vat-hidden')) {
        return; // Stop and wait for the correct HTML to be loaded.
      }

      // If we got here, it means we have the correct, unmodified HTML to work with.

      // 1. Find the other two price parts.
      const unwantedHiddenPrice = salePriceWrapper.querySelector('span.ymq-b2b-vat-hidden');
      const finalHtPrice = salePriceWrapper.querySelector('span.ymq-b2b-vat-price');

      // 2. Remove the unwanted intermediate price (e.g., €7.68).
      if (unwantedHiddenPrice) {
        unwantedHiddenPrice.remove();
      }

      // 3. Reveal the true original price.
      originalPriceElement.classList.remove('ymq-b2b-vat-hidden');
      originalPriceElement.style.display = 'inline-block'; // Ensure visibility

      // 4. If the final HT price exists, we do a full clean-up and re-assembly.
      if (finalHtPrice) {
          salePriceWrapper.innerHTML = ''; // Clear everything
          salePriceWrapper.appendChild(originalPriceElement); // Add back the original price
          salePriceWrapper.appendChild(finalHtPrice); // Add back the HT price
      }
      
      // 5. SAFETY: Mark the wrapper as processed so this code never runs on it again.
      salePriceWrapper.classList.add('b2b-price-is-fixed');
    });
  }

  // Set up the MutationObserver to watch for any changes to the page content.
  // This is the primary trigger for the fix.
  const observer = new MutationObserver(function() {
    fixB2bPriceDisplay();
  });

  // Start observing the entire page.
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Run it once right away in case the content is already there.
  fixB2bPriceDisplay();

}); 





document.addEventListener('DOMContentLoaded', function() {

  function fixB2bPriceDisplay() {
    
    // Find all <sale-price> wrappers that contain the specific B2B <del> tag
    // AND have not already been successfully processed by this script.
    document.querySelectorAll('sale-price:not(.b2b-price-is-fixed)').forEach(salePriceWrapper => {

      // Find the key element: the hidden "compare at" price.
      const originalPriceElement = salePriceWrapper.querySelector('del.ymq-b2b-cp-compare-price');

      // --- This is the new, more intelligent check ---
      // If this key element doesn't exist, OR if it's already visible, then do nothing.
      // We only proceed if the element exists AND is still hidden by the app.
      if (!originalPriceElement || !originalPriceElement.classList.contains('ymq-b2b-vat-hidden')) {
        return; // Stop and wait for the correct HTML to be loaded.
      }

      // If we got here, it means we have the correct, unmodified HTML to work with.

      // 1. Find the other two price parts.
      const unwantedHiddenPrice = salePriceWrapper.querySelector('span.ymq-b2b-vat-hidden');
      const finalHtPrice = salePriceWrapper.querySelector('span.ymq-b2b-vat-price');

      // 2. Remove the unwanted intermediate price (e.g., €7.68).
      if (unwantedHiddenPrice) {
        unwantedHiddenPrice.remove();
      }

      // 3. Reveal the true original price.
      originalPriceElement.classList.remove('ymq-b2b-vat-hidden');
      originalPriceElement.style.display = 'inline-block'; // Ensure visibility

      // 4. If the final HT price exists, we do a full clean-up and re-assembly.
      if (finalHtPrice) {
          salePriceWrapper.innerHTML = ''; // Clear everything
          salePriceWrapper.appendChild(originalPriceElement); // Add back the original price
          salePriceWrapper.appendChild(finalHtPrice); // Add back the HT price
      }
      
      // 5. SAFETY: Mark the wrapper as processed so this code never runs on it again.
      salePriceWrapper.classList.add('b2b-price-is-fixed');
    });
  }

  // Set up the MutationObserver to watch for any changes to the page content.
  // This is the primary trigger for the fix.
  const observer = new MutationObserver(function() {
    fixB2bPriceDisplay();
  });

  // Start observing the entire page.
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Run it once right away in case the content is already there.
  fixB2bPriceDisplay();

}); 

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
    
    // Create the B2B button element
    const b2bButton = document.createElement('button');
    b2bButton.className = 'b2b-access-btn';
    b2bButton.innerHTML = 'ACCÈS REVENDEUR B2B <img class="imageaccessb2b" style="max-width: 18px; height: auto; display: inline-block;" src="https://cdn.shopify.com/s/files/1/0588/6895/7382/t/10/assets/login.svg?v=1751197173" alt="Login">';
    
    // Add click event listener
    b2bButton.addEventListener('click', function() {
        // Replace with your desired action
        // Example: redirect to B2B login page
        window.location.href = 'https://mocybell.com/account/login#revendeur'; 
        
        // Or open a modal, show a form, etc.
        // alert('B2B Access clicked!');
    });
    
    // Find the header element
    const header = document.querySelector('.header');
    
    if (header) {
        // Create a container for the button
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'b2b-button-container';
        buttonContainer.appendChild(b2bButton);
        
        // Insert the button container at the beginning of the header
        header.insertBefore(buttonContainer, header.firstChild);
        
        // Function to update button colors based on header state
        function updateButtonColors() {
            const headerElement = document.querySelector('x-header.header');
            const button = document.querySelector('.b2b-access-btn');
            const icon = document.querySelector('.imageaccessb2b');
            const isHomepage = window.location.pathname === '/' || window.location.pathname === '';
            if (!headerElement || !button || !icon) return;
            // Check if we're on homepage
            
            
            if (!isHomepage) {
                // Not on homepage = always black text
                button.style.color = 'black';
                icon.style.filter = 'none'; // Black icon
                return; // Exit early, don't check header states
            }
            // Check if header has yellow background (is-filled, is-solid, or is being hovered)
            const hasYellowBackground = headerElement.classList.contains('is-filled') || 
                                      headerElement.classList.contains('is-solid') ||
                                      headerElement.matches(':hover');
            
            if (hasYellowBackground) {
                // Yellow background = black text
                button.style.color = 'black';
                icon.style.filter = 'none'; // Black icon
            } else {
                // Transparent background = white text
                button.style.color = 'white';
                icon.style.filter = 'brightness(0) invert(1)'; // White icon
            }
        }
        
        // Initial color update
        updateButtonColors();
        
        // Watch for class changes on header
        const headerObserver = new MutationObserver(updateButtonColors);
        const headerElement = document.querySelector('x-header.header');
        if (headerElement) {
            headerObserver.observe(headerElement, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
        
        // Also listen for scroll events to catch dynamic class additions
        window.addEventListener('scroll', updateButtonColors);
        
        // Listen for hover events on header
        if (headerElement) {
            headerElement.addEventListener('mouseenter', updateButtonColors);
            headerElement.addEventListener('mouseleave', updateButtonColors);
        }
    }
    
    // Add CSS styles
    const styles = `
        <style>
        .b2b-button-container {
            position: absolute;
            top: 35%;
            left: 8%;
            z-index: 1000;
        }

        .b2b-access-btn {
            border: none;
            padding: 8px 16px;
            font-size: 12px;
            font-weight: bold;
            text-transform: uppercase;
            border-radius: 4px;
            cursor: pointer;
            background: transparent;
            transition: all 0.3s ease;
            /* Initial state - will be overridden by JavaScript */
            color: white;
        }
        
        .imageaccessb2b {
            transition: filter 0.3s ease;
            /* Initial state - will be overridden by JavaScript */
            filter: brightness(0) invert(1);
        }
        
        .b2b-access-btn:hover {
            transform: translateY(-1px);
        }
        
        .b2b-access-btn:active {
            transform: translateY(0);
        }
        
        /* Responsive adjustments */
        @media (max-width: 768px) {
            .b2b-button-container {
                top: 5px;
                left: 10px;
            }
            
            .b2b-access-btn {
                padding: 6px 12px;
                font-size: 10px;
            }
        }
        
        /* Hide on very small screens if needed */
        @media (max-width: 480px) {
            .b2b-button-container {
                display: none;
            }
        }
        </style>
    `;
    
    // Inject the styles into the document head
    document.head.insertAdjacentHTML('beforeend', styles);
}); 
// B2B Login Page Content Modifier - FIXED VERSION with Hash Change Detection
(function() {
    'use strict';
    
    // A flag to ensure our code only runs once per URL change
    let hasModifiedForB2B = false;
    let currentHash = window.location.hash;
    
    function modifyLoginForB2B() {
        // Stop if the URL is not for B2B or if we have already run the script for this hash
        if (hasModifiedForB2B || !window.location.href.includes('revendeur')) {
            return;
        }
        
        console.log('Starting B2B login page modifications...');
        
        // --- All your modification logic goes here ---
        // Change main heading
        const mainHeading = document.querySelector('#login .h3');
        if (mainHeading) {
            mainHeading.textContent = 'CONNEXION ACCÈS PROFESSIONNEL';
        }
        
        // Change description text
        const description = document.querySelector('#login p');
        if (description) {
            description.textContent = 'Entrez votre email et mot de passe pour vous connecter :';
        }
        
        // Change submit button text
        const submitButton = document.querySelector('#customer_login button[type="submit"]');
        if (submitButton) {
            submitButton.textContent = 'SE CONNECTER';
        }
        
        // Change "No account" text and link
        const registerLink = document.querySelector('#customer_login a[href="/account/register"]');
        if (registerLink && registerLink.parentElement) {
            registerLink.parentElement.innerHTML = `
                <span class="text-subdued">Pas encore de compte professionnel ?</span>
                <a href="https://mocybell.com/pages/inscription-b2b" class="link-faded">S'inscrire (sous réservation de validation par nos équipes.)</a>
            `;
        }
        
        // Modify password recovery section
        const recoverHeading = document.querySelector('#recover .h3');
        if (recoverHeading) {
            recoverHeading.textContent = 'Récupération du mot de passe professionnel';
        }
        
        const recoverDescription = document.querySelector('#recover p');
        if (recoverDescription) {
            recoverDescription.textContent = 'Entrez votre email professionnel pour récupérer votre mot de passe :';
        }
        
        // Set the flag to true so this function doesn't run again for this hash
        hasModifiedForB2B = true;
        console.log('B2B login page modifications applied.');
    }
    
    function resetModificationFlag() {
        // Reset the flag when hash changes or URL changes
        hasModifiedForB2B = false;
        currentHash = window.location.hash;
        console.log('Reset modification flag for new hash:', currentHash);
    }
    
    function checkAndModify() {
        // Check if hash has changed
        if (currentHash !== window.location.hash) {
            resetModificationFlag();
        }
        
        // Run the modification function with a small delay to ensure DOM is ready
        setTimeout(modifyLoginForB2B, 150);
    }
    
    // Run when DOM is loaded
    document.addEventListener('DOMContentLoaded', checkAndModify);
    
    // Listen for hash changes (when clicking #revendeur button)
    window.addEventListener('hashchange', function() {
        console.log('Hash changed to:', window.location.hash);
        resetModificationFlag();
        checkAndModify();
    });
    
    // Listen for popstate (back/forward navigation)
    window.addEventListener('popstate', function() {
        console.log('Popstate event triggered');
        resetModificationFlag();
        checkAndModify();
    });
    
    // Also run immediately if the page is already loaded and has the hash
    if (document.readyState === 'loading') {
        // DOM is still loading, DOMContentLoaded will handle it
    } else {
        // DOM is already loaded, run immediately
        checkAndModify();
    }
    
})();

// B2B Registration Form Placeholder Script (unchanged)
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.ymq-b2b-registration-form')) {
        const formFields = document.querySelectorAll('.ymq-b2b-options-box');
        formFields.forEach(field => {
            const label = field.querySelector('.ymq-b2b-lable');
            const input = field.querySelector('.ymq-b2b-input-text, .ymq-b2b-input-password');
            if (label && input && !input.placeholder) {
                input.placeholder = label.textContent.trim().replace(' *', ''); // Set placeholder, remove asterisk
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', function() {
  
  let isB2B = false;

  // Check if the YMQ object and its nested properties exist
  if (window.ymq_b2b && window.ymq_b2b.customer && Array.isArray(window.ymq_b2b.customer.tags)) {
    // Check if the customer has the 'B2B' or 'PRO' tag
    if (window.ymq_b2b.customer.tags.includes('B2B') || window.ymq_b2b.customer.tags.includes('PRO')) {
      isB2B = true;
    }
  }

  // --- Your Logic Goes Here ---
  // Run the script ONLY if the user is NOT B2B
  if (!isB2B) {
    console.log("This is a NON-B2B user (or a logged-out visitor). Running your script now!");
    
 (function() {
  'use strict';
  
  let isProcessing = false;

  function addCustomDiscountBadge() {
    if (isProcessing) return;
    isProcessing = true;
    
    const lineItems = document.querySelectorAll('line-item');
    let totalQuantity = 0;
    let detectedCurrency = '€'; // Default fallback
    
    // Calculate total quantity across all line items
    lineItems.forEach(item => {
      const quantityInput = item.querySelector('.quantity-selector__input');
      if (quantityInput) {
        totalQuantity += parseInt(quantityInput.value) || 0;
      }
    });
    
    // Remove existing custom badges first
    document.querySelectorAll('.custom-discount-badge').forEach(badge => badge.remove());
    
    if (totalQuantity >= 2) {
      // Create array of all products with their quantities and prices
      let allProducts = [];
      lineItems.forEach(item => {
        const quantityInput = item.querySelector('.quantity-selector__input');
        
        // Try to find price element - check multiple selectors
        let priceElement = item.querySelector('.transcy-money') || 
                          item.querySelector('.ymq-b2b-price-hidden') ||
                          item.querySelector('sale-price span:last-child');
        
        if (quantityInput && priceElement) {
          const quantity = parseInt(quantityInput.value) || 0;
          
          // Extract price from text content
          const priceText = priceElement.textContent || priceElement.innerText;
          
          // Detect currency symbol from first product
          if (detectedCurrency === '€') {
            const currencyMatch = priceText.match(/[€$£¥₹₽¢₩₪₨₦₡₵₴₸₼₾]|CHF|USD|EUR|GBP/);
            if (currencyMatch) {
              detectedCurrency = currencyMatch[0];
            }
          }
          
          // Remove all currency symbols and text, handle both comma and dot as decimal separators
          let cleanPrice = priceText.replace(/[A-Za-z\s]/g, ''); // Remove letters and spaces
          // Handle different currency symbols and codes
          cleanPrice = cleanPrice.replace(/[€$£¥₹₽¢₩₪₨₦₡₵₴₸₼₾]|CHF|USD|EUR|GBP|SFr\./g, '');
          // If there's a comma followed by 2 digits at the end, it's likely a decimal separator
          if (/,\d{2}$/.test(cleanPrice)) {
            cleanPrice = cleanPrice.replace(',', '.');
          } else {
            // Otherwise, remove commas (they're likely thousands separators)
            cleanPrice = cleanPrice.replace(/,/g, '');
          }
          const price = parseFloat(cleanPrice) || 0;
          
          // Add each individual product to the array
          for (let i = 0; i < quantity; i++) {
            allProducts.push(price);
          }
        }
      });
      
      // Sort products by price (ascending) to give discount on cheapest items
      allProducts.sort((a, b) => a - b);
      
      // Calculate discount: for every 3 items, 1 is free + if 2 or more remaining, get 1 more free
      const freeItems = Math.floor(totalQuantity / 3);
      const remainingItems = totalQuantity % 3;
      const additionalFreeItems = remainingItems >= 2 ? 1 : 0;
      const totalFreeItems = freeItems + additionalFreeItems;
      
      // Calculate total discount based on cheapest free items
      let totalDiscount = 0;
      for (let i = 0; i < totalFreeItems; i++) {
        if (allProducts[i]) {
          totalDiscount += allProducts[i];
        }
      }
      
      // Add badges to all line items
      lineItems.forEach((lineItem, index) => {
        const customBadge = document.createElement('ul');
        customBadge.className = 'v-stack justify-items-start gap-1 unstyled-list custom-discount-badge';
        customBadge.setAttribute('role', 'list');
        
        // Format currency display
        let currencyDisplay = detectedCurrency;
        if (detectedCurrency === 'CHF') {
          currencyDisplay = 'CHF ';
        } else if (detectedCurrency.length > 1) {
          currencyDisplay = detectedCurrency + ' ';
        }
        
        // Show amount only on first product, text only on others
        const discountText = index === 0 
          ? `BUY 2 GET 1 FREE (-<span class="transcy-money">${currencyDisplay}${totalDiscount.toFixed(2)}</span>)`
          : `BUY 2 GET 1 FREE`;
        
        customBadge.innerHTML = `
          <li class="discount-badge text-xs">
            <svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon icon-discount" viewBox="0 0 24 24">
              <path d="M22.707 12.293l-11-11A1.002 1.002 0 0 0 11 1H2a1 1 0 0 0-1 1v9c0 .265.105.52.293.707l11 11a.997.997 0 0 0 1.414 0l9-9a.999.999 0 0 0 0-1.414zM7 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 9zm6 8.414L8.586 13 10 11.586 14.414 16 13 17.414zm3-3L11.586 10 13 8.586 17.414 13 16 14.414z" fill="currentColor"></path>
            </svg>${discountText}
          </li>
        `;
        
        const quantitySection = lineItem.querySelector('line-item-quantity');
        if (quantitySection) {
          quantitySection.parentNode.appendChild(customBadge);
        }
      });
    }
    
    isProcessing = false;
  }

  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const debouncedUpdate = debounce(addCustomDiscountBadge, 100);

  // Run on page load
  document.addEventListener('DOMContentLoaded', addCustomDiscountBadge);
  
  // Also run immediately if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addCustomDiscountBadge);
  } else {
    addCustomDiscountBadge();
  }

  // Listen for cart updates via fetch
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      if (args[0] && (args[0].includes('/cart') || args[0].includes('add'))) {
        setTimeout(debouncedUpdate, 300);
      }
      return response;
    });
  };

  // Listen for clicks on quantity buttons and add to cart buttons
  document.addEventListener('click', function(e) {
    if (e.target.closest('.quantity-selector__button') || 
        e.target.closest('[name="add"]') ||
        e.target.closest('.product-form__cart-button')) {
      setTimeout(debouncedUpdate, 400);
    }
  });

  // Listen for input changes
  document.addEventListener('input', function(e) {
    if (e.target.classList.contains('quantity-selector__input')) {
      setTimeout(debouncedUpdate, 200);
    }
  });

  // Observe cart drawer content changes
  function setupCartObserver() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            if (mutation.target.classList.contains('cart-drawer__items') || 
                mutation.target.closest('.cart-drawer__items') ||
                mutation.addedNodes.length > 0) {
              shouldUpdate = true;
            }
          }
        });
        if (shouldUpdate) {
          setTimeout(debouncedUpdate, 100);
        }
      });

      observer.observe(cartDrawer, { 
        childList: true, 
        subtree: true
      });

      // Also listen for cart drawer opening/showing
      const cartDrawerObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && 
              (mutation.attributeName === 'open' || mutation.attributeName === 'style')) {
            setTimeout(debouncedUpdate, 200);
          }
        });
      });

      cartDrawerObserver.observe(cartDrawer, { 
        attributes: true,
        attributeFilter: ['open', 'style']
      });
    }
  }

  // Setup observer immediately and after DOM load
  setupCartObserver();
  document.addEventListener('DOMContentLoaded', setupCartObserver);

  // Listen for custom cart events (if any)
  document.addEventListener('cart:updated', debouncedUpdate);
  document.addEventListener('cart:changed', debouncedUpdate);

})(); 

  } else {
    console.log("This is a B2B user. The script will NOT be executed.");
  }

}); 
 // Add "Accès PRO" next to login text in sidebar
document.addEventListener('DOMContentLoaded', function() {
    function addAccessProToSidebar() {
        // Find the header sidebar footer element
        const headerFooter = document.querySelector('.header-sidebar__footer');
        
        if (!headerFooter) {
            return;
        }
        
        // Find the login/account link
        const accountLink = headerFooter.querySelector('a.text-with-icon');
        
        if (!accountLink) {
            return;
        }
        
        // Check if the link text contains "Connexion" (login) or "Compte" (account)
        const linkText = accountLink.textContent.trim();
        const isLoginPage = linkText === 'Connexion';
        
        // Remove existing Accès PRO elements if they exist
        const existingSeparator = headerFooter.querySelector('.acces-pro-separator');
        const existingAccessPro = headerFooter.querySelector('.acces-pro-link');
        if (existingSeparator) existingSeparator.remove();
        if (existingAccessPro) existingAccessPro.remove();
        
        // Only add the elements if user is not connected (showing "Connexion")
        if (isLoginPage) {
            // Create separator
            const separator = document.createElement('span');
            separator.className = 'acces-pro-separator';
            separator.textContent = '';
            separator.style.cssText = `
                color: black;
                margin: 0 5px;
                font-size: 10px;
                text-transform: uppercase;
                font-weight: 500;
            `;
            
            // Create Accès PRO link
            const accessProLink = document.createElement('a');
            accessProLink.className = 'acces-pro-link text-with-icon smallcaps sm:hidden';
            accessProLink.href = 'https://mocybell.com/account/login#revendeur';
            accessProLink.target = '_self'; // Open in same window
            
            // Add click event to force refresh and close mobile menu
            accessProLink.addEventListener('click', function(e) {
                e.preventDefault();
                
                // First try to close any open mobile menu
                const mobileMenu = document.querySelector('.header-sidebar');
                if (mobileMenu) {
                    mobileMenu.style.display = 'none';
                }
                
                // Force reload by adding timestamp parameter to bypass cache
                const url = new URL(this.href);
                url.searchParams.set('_t', Date.now());
                window.location.href = url.toString();
            });
            accessProLink.style.cssText = `
                color: black;
                text-decoration: none;
                font-size: 10px;
                text-transform: uppercase;
                font-weight: 500;
                display: inline-flex;
                align-items: center;
                gap: 5px;
                cursor: pointer;
                transition: opacity 0.3s ease;
            `;
            
            // Create button text and icon
            accessProLink.innerHTML = `
                <img class="imageaccessb2b" style="max-width: 18px; height: auto; display: inline-block; filter: none;" src="https://cdn.shopify.com/s/files/1/0588/6895/7382/t/10/assets/login.svg?v=1751197173" alt="Login">
                ACCÈS REVENDEUR
            `;
            
            // Add hover effect
            accessProLink.addEventListener('mouseenter', function() {
                this.style.opacity = '0.8';
            });
            
            accessProLink.addEventListener('mouseleave', function() {
                this.style.opacity = '1';
            });
            
            // Insert the link after the existing account link
            accountLink.parentNode.insertBefore(accessProLink, accountLink.nextSibling);
        }
    }
    
    // Run the function initially
    addAccessProToSidebar();
    
    // Also run when the page content changes (for dynamic content)
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                // Check if the header footer content has changed
                const hasHeaderFooterChanges = Array.from(mutation.addedNodes).some(node => 
                    node.nodeType === 1 && (
                        node.querySelector('.header-sidebar__footer') || 
                        node.classList?.contains('header-sidebar__footer')
                    )
                );
                
                if (hasHeaderFooterChanges) {
                    setTimeout(addAccessProToSidebar, 100);
                }
            }
        });
    });
    
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});